<template>
	<div :class="filterClass" class="filter table-filter--since">
		<p>Age (days)</p>
		<ul>
			<li v-for="(data, dataIndex) in filterData.values" :key="dataIndex">
				<button
					:class="buttonClass(data.days, data.active)"
					:disabled="!data.active" class="table-filter--since__button" v-html="data.days"
					@click.prevent="setValue(data.days)"/>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	data() {
		return {
			filterValue: "",
		};
	},

	computed: {
		filterClass() {
			return {
				"filter--has-filter": !!this.filterValue,
			};
		},
	},

	props: {
		filter: {
			required: true,
			type: Function,
		},
		filterData: {
			required: true,
			type: Object,
		},
	},

	methods: {
		buttonClass(value, active) {
			return {
				"table-filter--since__button--active": this.filterValue && parseInt(value) === parseInt(this.filterValue),
				"table-filter--since__button--included": this.filterValue && parseInt(value) < parseInt(this.filterValue),
				"table-filter--since__button--disabled": !active,
			};
		},
		setValue(value) {
			if (value === this.filterValue) {
				return this.clear();
			}
			this.filterValue = value;
			this.apply();
		},
		apply() {
			this.filter(this.filterData.key, this.filterValue);
		},
		clear() {
			this.filterValue = "";
			this.$parent.clearFilter(this.filterData.key);
		},
	},

	created() {
		this.filterValue = this.filterData.value;
	},
};
</script>
